import { useState, useEffect, useContext } from "react";
import axios, { AxiosError } from "axios";
import * as React from "react";
import { makeStyles } from "@mui/styles";
import { RegistrationMessageScreen } from "./templates/RegistrationMessageScreen";
import { RegistrationFormScreen } from "./templates/RegistrationFormScreen";
import backgroundSvg from "../../../assets/SelfReg-Background.svg";
import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Slide, { SlideProps } from "@mui/material/Slide";
import {
  Box,
  Button,
  TextField,
  InputAdornment,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Fade,
  Zoom,
  Snackbar,
  Stack,
} from "@mui/material";

import { ReactComponent as CourseKeyIcon } from "../../../assets/SelfReg-CourseKeyIcon.svg";
import { Link, useHistory } from "react-router-dom";
import { logger } from "../../../services/logger";
import { v2theme } from "../../../styles/Theme";
import { ButtonZoom } from "../utils/ButtonZoom";
import { UniversalModalContext } from "../../../context/UniversalModalContext";
import { UniversalModalCtx } from "../../../interfaces";
import { VerifyEmail } from "./templates/VerifyEmail";
import { AccountExists } from "./templates/AccountExists";
import { StepZero } from "./registration-steps/StepZero";
import { AccessibilityStep } from "./registration-steps/AccessibilityStep";
import { UserDetailsStep } from "./registration-steps/UserDetailsStep";
import { generateGtmEvent, getSupportLink } from "../../../Helpers";
import { useAWSWAFCaptchaAxios } from "../../../hooks/useAWSWAFCaptchaAxios";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    backgroundImage: `url(${backgroundSvg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  stepSelect0: {
    padding: "0px",
  },
  cardContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  formCardCentered: {
    backgroundColor: "#FFFFFF",
    color: "#000000E6",
    borderRadius: "8px",
    padding: "2rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    transition: "height 200ms ease-in-out",
  },
  formCard: {
    backgroundColor: "#FFFFFF",
    color: "#000000E6",
    borderRadius: "8px",
    padding: "2rem",
  },
  link: {
    textDecoration: "underline",
    color: "inherit",
    cursor: "pointer",
    background: "none",
    border: "none",
  },
  checkIcon: {
    "& path": {
      fill: "green",
    },
  },
  pad8: {
    padding: "0px 0px 8px 0px",
  },
  numberInputRoot: {
    // workaround for MUI bug that occurs on textfields with changed font size
    "& .MuiOutlinedInput-notchedOutline legend": {
      width: "4.5rem",
    },
    "& .MuiOutlinedInput-input": {
      paddingLeft: "8px",
    },
    "& .MuiFormHelperText-root": {
      position: "absolute",
      bottom: "-1.4rem",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
  numberInput: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      display: "none",
    },
  },
  stepperContainer: {
    width: "40%",
  },
  stepperClass: {
    paddingBottom: "16px",
  },
  backToSignUpButton: {
    padding: "0px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "150px",
    height: "45px",
    boxShadow: "none",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "150px",
      height: "45px",
      textDecoration: "underline",
      color: theme.palette.text.primary,
      boxShadow: "none",
      transform: "none",
    },
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: theme.palette.primary.main,
    }),
    "& .QontoStepIcon-completedIcon": {
      color: theme.palette.primary.main,
      zIndex: 1,
      fontSize: 18,
    },
    "& .QontoStepIcon-circle": {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  })
);
const offsetStyle = "72px";

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

const steps = ["form screen 1", "form screen 2", "form screen 3"];

interface IClassVerification {
  grade?: Number;
  class_id?: Number;
  school_id?: Number;
}

export type Screens =
  | "accountexists"
  | "verifyemail"
  | "registrationform"
  | "coursecode"
  | "";

interface SelfRegistrationProps {
  screen?: Screens;
  isDemoMode?: boolean;
}

const HandleDataLayer = (
  event: string,
  action: string,
  name: string,
  type: string,
  region: string,
  section: string,
  text: string
) => {
  generateGtmEvent({ event, action, name, type, region, section, text });
};

export const SelfRegistration = (props: SelfRegistrationProps) => {
  const { screen = "coursecode", isDemoMode = false } = props;
  const pathString = isDemoMode ? "demo-registration" : "self-registration";
  const classes = useStyles();
  const history = useHistory();
  const universalModalCtx = useContext(UniversalModalContext) as UniversalModalCtx;
  // Set courseCode to query param "code" if exists
  const queryParams = new URLSearchParams(window.location.search);
  const queryCode = queryParams.get("code") as string;
  const [classCode, setClassCode] = useState(
    queryCode ? queryCode : isDemoMode ? process.env.REACT_APP_DEMO_CODE ?? "" : ""
  );
  const [classCodeError, setClassCodeError] = useState<string>();
  // Stores the course details returned from verifying courseCode
  // Includes class_id as classId and school_id as schoolId
  const [course, setCourse] = useState<IClassVerification>();
  const [isDemo, setIsDemo] = useState<boolean>(isDemoMode);
  const [registrationPage, setRegistrationPage] = useState(0);
  //Stepper component
  const [activeStep, setActiveStep] = useState(0);
  const [checkedAge, setCheckedAge] = useState(false);
  const [checkedAccessibility, setCheckedAccessibility] = useState(false);
  const [checkedConsent, setCheckedConsent] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [createSuccess, setCreateSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const captchaAxios = useAWSWAFCaptchaAxios();

  const supportLink = getSupportLink(false);

  useEffect(() => {
    if (checkedAge && checkedConsent) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [checkedAge, checkedConsent]);

  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleAccountExist = (email: string) => {
    const api = process.env.REACT_APP_BACKEND_API;
    axios.get(api + "/cognito-user/" + email).then((response) => {
      if (response.data.UserStatus === "FORCE_CHANGE_PASSWORD") {
        console.log("Account already exist. verify email");
        history.push(`/${pathString}/verify-email`);
      } else {
        history.push(`/${pathString}/account-exists`);
      }
    });
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const api = process.env.REACT_APP_BACKEND_API;
    const data = {
      email: email,
      first_name: firstName,
      last_name: lastName,
      grade: course ? Number(course.grade) : "",
      class_id: course ? Number(course.class_id) : "",
      school_id: course ? Number(course.school_id) : "",
      accessibility: checkedAccessibility,
    };
    axios
      .post(api + "/cognito-users-sr", data)
      .then(function (response) {
        if (response.status === 200) {
          setCreateSuccess(true);
          setMessage("User Created Successfully!");
          handleSnackbarClick();
          history.push(`/${pathString}/verify-email`);
        } else {
          setCreateSuccess(false);
          setMessage("Something wrong! please try again later");
          handleSnackbarClick();
          console.log("There is an error creating user try again later");
        }
      })
      .catch((err) => {
        logger.error(err);
        if (err.response.data.name === "UsernameExistsException") {
          handleAccountExist(email);
        } else {
          setCreateSuccess(false);
          setMessage("Something went wrong! please try again later");
          handleSnackbarClick();
        }
      });
  };

  const MACSFeatures = [
    "Provides real-time assistance every step of the way.",
    "Recommends content based on individual learning progress.",
    "Problem solving built around social and emotional learning.",
  ];

  const handleSnackbarClick = () => {
    setSnackBarOpen(true);
  };

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackBarOpen(false);
  };

  const handleBackButtonPress = (
    e: React.MouseEvent<HTMLButtonElement>,
    page: Screens
  ) => {
    history.push(`/${pathString}?code=${classCode}`);
  };

  const handleSignInButton = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    history.push("/");
  };

  const handleAccessibility = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedAccessibility(event.target.checked);
  };

  const handleRegistrationPage = (
    e: React.MouseEvent<HTMLButtonElement>,
    pageID: number
  ) => {
    setActiveStep(pageID);
    setRegistrationPage(pageID);
  };
  const handleAgeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedAge(event.target.checked);
  };
  const handleConsentCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedConsent(event.target.checked);
  };
  //
  const handleCodeVerification = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    HandleDataLayer(
      "link",
      "click",
      "onclick",
      "internal link",
      "main content",
      "join your class",
      "continue"
    );
    setClassCodeError(undefined);
    const api = process.env.REACT_APP_BACKEND_API;
    if (classCode) {
      await captchaAxios
        .get(api + "/class/class-code/" + classCode)
        .then((res) => {
          if (res.data) {
            setIsDemo(res.data.is_demo);
          }
          if (res.data.school_id && res.data.class_id) {
            setCourse(res.data);
            history.push(`/${pathString}/registration-form`);
          }
        })
        .catch((err: Error | AxiosError) => {
          console.log("Axios Catch", err);
          if (axios.isAxiosError(err) && err.response) {
            // @ts-ignore
            setClassCodeError(err.response.data.message as string);
          }
          logger.error(err);
        });
    } else {
      console.log("The class code is invalid");
      setClassCodeError("A class code is required");
    }
  };
  //
  const handleAccountVerification = async (e: React.MouseEvent<HTMLButtonElement>) => {
    setClassCodeError(undefined);
    const api = process.env.REACT_APP_BACKEND_API;
    const data = {
      email: email,
    };
    await axios
      .post(api + "/cognito-users-verify", data)
      .catch((err: Error | AxiosError) => {
        logger.error(err);
      });
  };

  useEffect(() => {
    if (screen !== "coursecode" || !screen) {
      if (!classCode || !course) {
        history.push(`/${pathString}`);
      }
    }
    if (screen === "verifyemail" || screen === "accountexists") {
      if (!email || !firstName || !lastName || !classCode || !course) {
        history.push(`/${pathString}`);
      }
    }
  }, [screen, history, email, firstName, lastName, classCode, course, pathString]);

  const termsOfServiceText = (section: string) => (
    <>
      {" "}
      By proceeding, you agree to our
      <button
        onClick={() => {
          HandleDataLayer(
            "link",
            "click",
            "onclick",
            "internal link",
            "main content",
            section,
            "terms of use and privacy policy"
          );
          universalModalCtx.setTosModalOpen(true);
        }}
        className={classes.link}
        style={{ paddingRight: "0px" }}>
        Terms of use and Privacy Policy
      </button>
      <span>.</span>
    </>
  );
  type TransitionProps = Omit<SlideProps, "direction">;

  function TransitionUp(props: TransitionProps) {
    return <Slide {...props} direction="up" />;
  }

  const renderSwitch = (onScreen: Screens) => {
    switch (onScreen) {
      case "accountexists":
        return (
          <AccountExists>
            <ButtonZoom
              sx={{ width: "186px", padding: "0px !important", height: "62px" }}
              size="large"
              variant="contained"
              color="primary"
              onClick={(e) => {
                HandleDataLayer(
                  "link",
                  "click",
                  "onclick",
                  "internal link",
                  "main content",
                  "your account already exists",
                  "log in to digit"
                );
                handleSignInButton(e);
              }}>
              Log in to Digit
            </ButtonZoom>
            <Button
              size="medium"
              className={classes.backToSignUpButton}
              variant="contained"
              sx={{ marginLeft: "-0.85em", marginTop: "24px" }}
              startIcon={<ArrowBackIcon style={{ width: "16px", height: "16px" }} />}
              onClick={(e) => history.push(`/${pathString}/registration-form`)}>
              Back to sign up
            </Button>
          </AccountExists>
        );
      case "verifyemail":
        return (
          <VerifyEmail email={email}>
            <ButtonZoom
              sx={{ width: "186px", padding: "0px !important", height: "62px" }}
              type="submit"
              size="large"
              variant="outlined"
              color="primary"
              onClick={(e) => {
                HandleDataLayer(
                  "link",
                  "click",
                  "onclick",
                  "internal link",
                  "main content",
                  "please verify your email",
                  "resend email"
                );
                handleAccountVerification(e);
              }}>
              Resend email
            </ButtonZoom>
            <Button
              size="medium"
              className={classes.backToSignUpButton}
              variant="contained"
              sx={{ marginLeft: "-0.85em", marginTop: "24px" }}
              startIcon={<ArrowBackIcon style={{ width: "16px", height: "16px" }} />}
              onClick={(e) => history.push(`/${pathString}/registration-form`)}>
              Back to sign up
            </Button>
          </VerifyEmail>
        );
      case "registrationform":
        return (
          <RegistrationFormScreen
            header="Almost there!"
            subHeader={
              <Box sx={{ fontWeight: 400, color: "#ffffff" }}>
                {isDemo === true ? (
                  <>
                    You are accessing the <strong>Digit Demo Course</strong>, which
                    includes the <strong>Pre-Algebra</strong> course. This demo course has{" "}
                    <strong>no expiration date</strong>, allowing you to explore at your
                    own pace.
                  </>
                ) : (
                  <>
                    You are creating an account for Digit. Digit is a tool with one goal:
                    Help you build confidence in Math.
                  </>
                )}
                {isDemo === true ? (
                  <>
                    <Typography
                      component="h5"
                      variant="h5"
                      style={{
                        marginTop: "2rem",
                        marginBottom: "1rem",
                        fontSize: 24,
                        fontWeight: "bold",
                        color: "#ffffff",
                      }}>
                      What Digit offers:
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography
                      component="h5"
                      variant="h5"
                      style={{
                        marginTop: "2rem",
                        marginBottom: "1rem",
                        fontSize: 24,
                        fontWeight: "bold",
                        color: "#ffffff",
                      }}>
                      Sign up for free
                    </Typography>
                    Digit is a free and open tool.{" "}
                    {termsOfServiceText("sign up for free")}
                  </>
                )}
                <List style={{ marginTop: "1rem" }}>
                  {MACSFeatures.map((feature, index) => (
                    <ListItem key={index} style={{ padding: "0rem 0rem" }}>
                      <ListItemIcon style={{ minWidth: "unset", marginRight: "1rem" }}>
                        <CheckIcon sx={{ color: "#FF7F32" }} />
                      </ListItemIcon>
                      <ListItemText primary={feature} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            }>
            <Box
              className={classes.formCardCentered}
              sx={{
                width: "480px",
                height: ["446px", "370px", "352px"][registrationPage],
              }}>
              <Box className={classes.cardContainer}>
                <div className={classes.stepperContainer}>
                  <Stepper
                    className={classes.stepperClass}
                    activeStep={activeStep}
                    connector={<QontoConnector />}>
                    {steps.map((label, index) => (
                      <Zoom
                        in={
                          registrationPage === 0 ||
                          registrationPage === 1 ||
                          registrationPage === 2
                        }
                        timeout={2000}
                        key={`${index}${label}`}>
                        <Step
                          key={label}
                          className={index === 0 ? classes.stepSelect0 : undefined}>
                          <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
                        </Step>
                      </Zoom>
                    ))}
                  </Stepper>
                </div>
                <div className={classes.pad8}>
                  <Typography component="span" variant="h4">
                    {isDemo === true ? "Create your demo account" : "Create your account"}
                  </Typography>
                </div>
                {/* If value of registration page is 0, display the confirmation section, else display account details  */}
                {registrationPage === 0 && (
                  <StepZero
                    checkedAge={checkedAge}
                    checkedConsent={checkedConsent}
                    handleAgeCheckbox={handleAgeCheckbox}
                    handleBack={handleBackButtonPress}
                    handleConsentCheckbox={handleConsentCheckbox}
                    handleNext={handleRegistrationPage}
                    isDisabled={isDisabled}
                    termsOfServiceText={termsOfServiceText("create your account")}
                  />
                )}
                {registrationPage === 1 && (
                  <Fade in={true} timeout={1000}>
                    <div>
                      <UserDetailsStep
                        email={email}
                        firstName={firstName}
                        lastName={lastName}
                        handleBack={(e) => {
                          handleRegistrationPage(e, 0);
                        }}
                        handleNext={(e) => {
                          handleRegistrationPage(e, 2);
                        }}
                        isDisabled={isDisabled || !firstName || !lastName || !email}
                        setFirstName={setFirstName}
                        setLastName={setLastName}
                        setEmail={setEmail}></UserDetailsStep>
                    </div>
                  </Fade>
                )}
                {registrationPage === 2 && (
                  <>
                    <AccessibilityStep
                      checkedAccessibility={checkedAccessibility}
                      handleAccessibility={handleAccessibility}
                      handleBack={(e) => {
                        handleRegistrationPage(e, 1);
                      }}
                      handleNext={(e) => {
                        handleSubmit(e);
                      }}
                      isDisabled={isDisabled || !firstName || !lastName || !email}
                    />
                    <Snackbar
                      TransitionComponent={TransitionUp}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={snackBarOpen}
                      autoHideDuration={6000}
                      onClose={handleSnackbarClose}>
                      <Alert
                        onClose={handleSnackbarClose}
                        severity={createSuccess ? "success" : "error"}
                        sx={{ width: "100%" }}>
                        {message}
                      </Alert>
                    </Snackbar>
                  </>
                )}
              </Box>
            </Box>
          </RegistrationFormScreen>
        );
      case "coursecode":
      default:
        return (
          <RegistrationMessageScreen
            header={isDemo ? "Join your demo class" : "Join your class"}
            subHeader={
              isDemo ? (
                <>
                  The demo class code has been pre-filled for you. Simply continue to get
                  started with Digit.{termsOfServiceText("join your demo class class")}
                </>
              ) : (
                <>
                  Enter the class code provided by your teacher or administrator to begin
                  using Digit. {termsOfServiceText("join your class")}
                </>
              )
            }>
            <form onSubmit={handleCodeVerification}>
              <Box className={classes.formCard} style={{ maxWidth: "620px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "32px",
                  }}>
                  <TextField
                    type="text"
                    label="Class code"
                    className={classes.numberInputRoot}
                    variant="outlined"
                    placeholder=""
                    value={classCode}
                    disabled={isDemo}
                    onChange={(e) => {
                      HandleDataLayer(
                        "form",
                        "click",
                        "onclick",
                        "blur",
                        "main content",
                        "join your class ^ class code",
                        e.target.value.toUpperCase()
                      );
                      setClassCode(e.target.value.toUpperCase());
                    }}
                    error={classCodeError ? true : false}
                    helperText={classCodeError ? classCodeError : undefined}
                    size="medium"
                    sx={{
                      flexGrow: 2,
                      color: "#000000B8",
                    }}
                    InputLabelProps={{}}
                    inputProps={{ maxLength: 8 }}
                    InputProps={{
                      classes: { input: classes.numberInput },
                      style: {
                        paddingLeft: "18px",
                        color: "#000000B8",
                        lineHeight: "48px",
                        fontSize: "40px",
                        fontFamily: "Roboto Mono",
                        letterSpacing: "16px",
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <CourseKeyIcon style={{ color: "#666666" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    sx={{
                      width: "auto",
                      height: "62px",
                      padding: " 21px 32px",
                    }}
                    disabled={classCode.length !== 8}
                    type="submit"
                    size="large"
                    variant="contained"
                    color="secondary">
                    Continue
                  </Button>
                </div>
                <Typography
                  component="p"
                  sx={{
                    marginTop: "2rem",
                    textAlign: "center",
                    color: "#5D5D5D",
                    fontSize: 14,
                  }}>
                  Have questions? Reach out to us{" "}
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      HandleDataLayer(
                        "link",
                        "click",
                        "onclick",
                        "internal link",
                        "main content",
                        "join your class",
                        "contact support for help"
                      );
                      window.open(supportLink, "_blank", "noopener,noreferrer");
                    }}
                    className={classes.link}
                    to={supportLink}>
                    here
                  </Link>
                  {"."}
                </Typography>
              </Box>
            </form>
          </RegistrationMessageScreen>
        );
    }
  };

  return (
    <Stack
      height={{ xs: `100%`, md: `calc(100vh - ${offsetStyle})` }}
      minHeight={{ xs: `100vh`, md: `calc(100vh - ${offsetStyle})` }}
      className={classes.container}
      id="main">
      {renderSwitch(screen)}
    </Stack>
  );
};
